import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import qrActions from "../../../redux/qr/actions";
import { useProjectState } from "../../../context/stateContext";
import QRUserComponent from "../../../components/User/QRUserComponent/QRUserComponent";

const { getQRUsers } = qrActions;

const QRUsers = () => {
  const { selectedOrganization } = useProjectState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getQRUsers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return <QRUserComponent />;
};

export default QRUsers;
